import { fetchData } from '../DAcApplication/components/actions';
export const getAdditionalDocs = async (_ref, applicationId) => {
  let {
    apiUrl = '',
    apiKey = '',
    userTokken = null,
    sessionId = ''
  } = _ref;
  const url = `${apiUrl}/v1/proxy/application/required/${applicationId}/documents`;
  const requestOptions = {
    method: 'GET'
  };
  const result = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    isTokkenValue: true,
    userTokken,
    isGetRequest: true
  });
  return result;
};
export const resubmitApplication = async (_ref2, applicationId) => {
  let {
    apiUrl = '',
    apiKey = '',
    userTokken = null,
    sessionId = ''
  } = _ref2;
  const data = {
    applicationId
  };
  const url = `${apiUrl}/v1/orc/application/${applicationId}/resubmit`;
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(data)
  };
  const result = await fetchData(url, requestOptions, {
    apiKey,
    sessionId,
    isTokkenValue: true,
    userTokken
  });
  return result;
};